import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect } from 'react';

import Gates from '../statsig/gates';

export const usePostieTrackingInit = (): void => {
  const { checkGate } = useStatsigClient();

  useEffect(() => {
    if (!checkGate(Gates.PostieTrackingPixel)) return;

    if (window.letterpress) return;

    const script = document.createElement('script');
    script.innerHTML = `
      (function(z,i,p,c,o,d,e){z[c]||(z[c]=function(){(z[c].q=z[c].q||[]).
      push(arguments)},z[c].q=z[c].q||[],d=i.createElement(p),d.async=1,d.
      src=o,e=i.getElementsByTagName(p)[0],e.parentNode.insertBefore(d,e))
      })(window,document,"script","letterpress","//scripts.postie.com/bpeoxnvp/lp.1.js");
    `;
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const trackPostieEvent = (command: string, ...args: any[]): void => {
  // Set a small timeout to ensure the script has time to load
  setTimeout(() => {
    if (window.letterpress) {
      window.letterpress(command, ...args);
    }
  }, 1000);
};
